import React from "react";
/* This files links all pages components "entry points" of a project */
// MODULES_APPEND_INDEX_ON_IMPORTS

export const modules = [
  {
    id: "404",
    loader: React.lazy(() => import("@/reactPages/not-found")),
  },
  {
    id: "500",
    loader: React.lazy(() => import("@/reactPages/error")),
  },
  {
    id: "Home",
    loader: React.lazy(() => import("@/reactPages/home/index")),
  },
  {
    id: "MyData",
    loader: React.lazy(() => import("@/reactPages/mi-perfil/index")),
  },
  {
    id: "MyConsents",
    loader: React.lazy(() => import("@/reactPages/mi-perfil/mis-consentimientos")),
  },
  {
    id: "ConsentDetail",
    loader: React.lazy(() => import("@/reactPages/mi-perfil/mis-consentimientos/detalle")),
  },
  {
    id: "MyConsentsBasics",
    loader: React.lazy(() => import("@/reactPages/mi-perfil/mis-consentimientos/basicos")),
  },
  {
    id: "MyConsentsAdvertising",
    loader: React.lazy(() => import("@/reactPages/mi-perfil/mis-consentimientos/publicidad")),
  },
  {
    id: "MyConsentsOpenGateway",
    loader: React.lazy(() => import("@/reactPages/mi-perfil/mis-consentimientos/open-gateway")),
  },
  // {
  //   id: "ConsentLanding",
  //   loader: React.lazy(() => import("@/reactPages/mi-perfil/mis-consentimientos/mejorar-mi-experiencia")),
  // },
  {
    id: "MyProducts",
    loader: React.lazy(() => import("@/reactPages/mis-productos/index")),
  },
  {
    id: "Menu",
    loader: React.lazy(() => import("@/reactPages/mis-productos/menu/index")),
  },
  {
    id: "InternetDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/internet-detail/index")
    ),
  },
  {
    id: "SegundaFibraDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/segunda-fibra-detail/index")
    ),
  },
  {
    id: "FibraAdicionalDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/fibra-adicional-detail/index")
    ),
  },
  {
    id: "SaludDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/salud-detail/index")
    ),
  },
  {
    id: "GamePassDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/game-pass-detail/index")
    ),
  },
  {
    id: "MobileInsuranceDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/mobile-insurance-detail/index")
    ),
  },
  {
    id: "CarDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/car-detail/index")
    ),
  },
  {
    id: "AlarmasDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/alarmas-detail/index")
    ),
  },
  {
    id: "FijoDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/fijo-detail/index")
    ),
  },
  {
    id: "MobileLineDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/mobile-line-detail/index")
    ),
  },
  {
    id: "MovistarProsegurAlarmas",
    loader: React.lazy(() => import("@/reactPages/servicing")),
  },
  {
    id: "Solar360",
    loader: React.lazy(() => import("@/reactPages/servicing")),
  },
  {
    id: "SaludTelemedicina",
    loader: React.lazy(() => import("@/reactPages/servicing")),
  },
  {
    id: "RelojTeCuida",
    loader: React.lazy(() => import("@/reactPages/servicing")),
  },
  {
    id: "MovistarMoney",
    loader: React.lazy(() => import("@/reactPages/servicing")),
  },
  {
    id: "XBoxGamePass",
    loader: React.lazy(() => import("@/reactPages/servicing")),
  },
  {
    id: "SeguroHogar",
    loader: React.lazy(() => import("@/reactPages/servicing")),
  },
  {
    id: "SeguroDispositivo",
    loader: React.lazy(() => import("@/reactPages/servicing")),
  },
  {
    id: "HealthDistri",
    loader: React.lazy(() => import("@/reactPages/servicing-distri")),
  },
  {
    id: "InsuranceDistri",
    loader: React.lazy(() => import("@/reactPages/servicing-distri")),
  },
  {
    id: "GlobalManagment",
    loader: React.lazy(() =>
      import("@/reactPages/managments/general-managment")
    ),
  },
  {
    id: "MobileManagment",
    loader: React.lazy(() =>
      import("@/reactPages/managments/general-managment")
    ),
  },
  {
    id: "MobileManagmentBloqs",
    loader: React.lazy(() => import("@/reactPages/managments/bloqueos")),
  },
  {
    id: "PhoneManagmentBloqs",
    loader: React.lazy(() => import("@/reactPages/managments/phone-blocks")),
  },
  {
    id: "PhoneMoreManagment",
    loader: React.lazy(() =>
      import("@/reactPages/managments/phone-more-managment")
    ),
  },
  {
    id: "PhoneDetourLandLine",
    loader: React.lazy(() => import("@/reactPages/managments/phone-detour")),
  },
  {
    id: "MobileManagmentImeiPuk",
    loader: React.lazy(() => import("@/reactPages/managments/imei-puk")),
  },
  {
    id: "MobileManagmentProduct",
    loader: React.lazy(() => import("@/reactPages/managments/line-mobile")),
  },
  {
    id: "PhoneManagment",
    loader: React.lazy(() =>
      import("@/reactPages/managments/general-managment")
    ),
  },
  {
    id: "PhoneManagementDetail",
    loader: React.lazy(() => import("@/reactPages/managments/phone-detail")),
  },
  {
    id: "InternetManagment",
    loader: React.lazy(() =>
      import("@/reactPages/managments/general-managment")
    ),
  },
  {
    id: "TvManagment",
    loader: React.lazy(() =>
      import("@/reactPages/managments/general-managment")
    ),
  },
  {
    id: "ChangePassword",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/cambio-contrasena/index")
    ),
  },
  {
    id: "Usages",
    loader: React.lazy(() => import("@/reactPages/mis-productos/usages/index")),
  },
  {
    id: "UsageDetails",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/usages/usage-details/index")
    ),
  },
  {
    id: "DeviceDetails",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/devices-detail")
    ),
  },
  // {
  //   id: 'usageDetailsPrepay',
  //   loader: React.lazy(() => import('@/reactPages/UsageDetailsPrepay')),
  // },
  // {
  //   id: 'usageDetailsPrepayNovum',
  //   loader: React.lazy(() => import('@/reactPages/UsageDetailsPrepay')),
  // },
  {
    id: "TvDetail",
    loader: React.lazy(() => import("@/reactPages/mis-productos/tv-detail")),
  },
  {
    id: "Bills",
    loader: React.lazy(() => import("@/reactPages/my-bills")),
  },
  {
    id: "AllBills",
    loader: React.lazy(() => import("@/reactPages/all-bills")),
  },
  {
    id: "BillsDetails",
    loader: React.lazy(() => import("@/reactPages/bill-detail")),
  },
  {
    id: "PrepagoBillsDetails",
    loader: React.lazy(() => import("@/reactPages/bill-detail-prepago")),
  },
  {
    id: "ExtraExpense",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/usages/extra-expense")
    ),
  },
  {
    id: "CitaPrevia",
    loader: React.lazy(() => import("@/reactPages/mi-perfil/cita-previa")),
  },
  {
    id: "PackDetail",
    loader: React.lazy(() => import("@/reactPages/mis-productos/pack-detail")),
  },
  {
    id: "ProteccionDigitalDetail",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/proteccion-digital-detail")
    ),
  },
  {
    id: "ProteccionDigitalEsencialMenu",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/proteccion-digital-esencial-menu")
    ),
  },
  {
    id: "ProteccionDigitalEsencialActivation",
    loader: React.lazy(() =>
      import(
        "@/reactPages/mis-productos/proteccion-digital-esencial-activation"
      )
    ),
  },
  {
    id: "ProteccionDigitalEsencialDesactivation",
    loader: React.lazy(() =>
      import(
        "@/reactPages/mis-productos/proteccion-digital-esencial-desactivation"
      )
    ),
  },
  {
    id: "ProviderActivation",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/tv-detail/provider-activation")
    ),
  },
  {
    id: "PerplexityActivation",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/perplexity-activation")
    ),
  },
  {
    id: "Traceability",
    loader: React.lazy(() => import("@/reactPages/mis-productos/traceability")),
  },
  {
    id: "Support",
    loader: React.lazy(() => import("@/reactPages/support")),
  },
  {
    id: "Autodiagnostico",
    loader: React.lazy(() => import("@/reactPages/support/autodiagnostico")),
  },
  {
    id: "BreakdownUnresolvedDetail",
    loader: React.lazy(() =>
      import("@/reactPages/support/breakdown-unresolved-detail")
    ),
  },
  {
    id: "OtpValidation",
    loader: React.lazy(() => import("@/reactPages/otp/index")),
  },
  {
    id: "SmartWifi",
    loader: React.lazy(() => import("@/reactPages/mis-productos/smart-wifi")),
  },
  {
    id: "SeguimientoPedidos",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/seguimiento-pedidos")
    ),
  },
  {
    id: "LineManagementDetail",
    loader: React.lazy(() =>
      import("@/reactPages/managments/line-mobile-detail")
    ),
  },
  {
    id: "BillAddress",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/direccion-de-facturacion")
    ),
  },
  {
    id: "BillAddressSearcher",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/direccion-de-facturacion/cambiar-direccion-de-facturacion")
    ),
  },
  {
    id: "EsimLineManagementDetail",
    loader: React.lazy(() =>
      import("@/reactPages/managments/line-mobile-e-sim")
    ),
  },
  {
    id: "EcoBill",
    loader: React.lazy(() =>
      import("@/reactPages/my-bills/eco-bill")
    ),
  },
  {
    id: "OnboardingHome",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/onboarding-home")
    ),
  },
  {
    id: "OnboardingConformation",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/onboarding-conformation")
    ),
  },
  {
    id: "OnboardingVerifyContactMeans",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/onboarding-verify-contact-means") 
    ),
  },
  {
    id: "OnboardingNewContact",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/onboarding-new-contact") 
    ),
  },
  {
    id: "OnboardingConsent",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/onboarding-consents") 
    ),
  },
  {
    id: "SendCode",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/send-code") 
    ),
  },
  {
    id: "VerifyCode",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/verify-code") 
    ),
  },
  {
    id: "ChangeEndScreen",
     loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/end-screen-change") 
    ),
  },
  {
    id: "Claims",
    loader: React.lazy(() =>
      import("@/reactPages/claims")
    ),
  },
  {
    id: "DetailClaim",
    loader: React.lazy(() =>
      import("@/reactPages/claims/detail")
    ),
  },
  {
    id: "BillsManagments",
     loader: React.lazy(() =>
      import("@/reactPages/managments/bills") 
    ),
  },
    {
    id: "BillsManagmentsRecharge",
     loader: React.lazy(() =>
      import("@/reactPages/my-bills/recharge") 
    ),
  },
  {
    id: "ProfileManagments",
     loader: React.lazy(() =>
      import("@/reactPages/managments/profile") 
    ),
  },
  {
    id: "ChatGPTActivation",
    loader: React.lazy(() =>
      import("@/reactPages/mis-productos/chatgpt-activation")
    ),
  },
  {
    id: "DebtPayment",
    loader: React.lazy(() =>
      import("@/reactPages/debt-payment")
    ),
  },
  {
    id: "FTTR",
     loader: React.lazy(() =>
      import("@/reactPages/mis-productos/fttr") 
    ),
  },
  {
    id: "AditionalLines",
     loader: React.lazy(() =>
      import("@/reactPages/mis-productos/aditional-lines") 
    ),
  },
  {
    id: "FuncionalitiesTv",
     loader: React.lazy(() =>
      import("@/reactPages/mis-productos/tv-detail/funcionalities") 
    ),
  },
  {
    id: "RecharguePrepaid",
     loader: React.lazy(() =>
      import("@/reactPages/managments/line-mobile/recharge-prepaid") 
    ),
  },
  {
    id: "AnticipatedPrepaid",
    loader: React.lazy(() =>
      import("@/reactPages/managments/line-mobile/anticipate-prepaid") 
    ),
  },
  {
    id: "Cerberus",
    loader: React.lazy(() =>
      import("@/reactPages/cerberus/main") 
    ),
  },
  {
    id: "CerberusReport",
    loader: React.lazy(() =>
      import("@/reactPages/cerberus/report") 
    ),
  },
  {
    id: "FastPass",
    loader: React.lazy(() =>
      import("@/reactPages/fast-pass") 
    ),
  },
  {
   id: "ChangeEmail",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/cambio-email")
    ),
  },
  {
    id: "ChangePhone",
    loader: React.lazy(() =>
      import("@/reactPages/mi-perfil/cambio-telefono"))
  },
  {
    id: "EsimHome",
    loader: React.lazy(() =>
      import("@/reactPages/managments/line-mobile-e-sim/home") 
    ),
  }
  // MODULES_APPEND_INDEX_ON_MODULES
];
